import { matchTerms } from "./matchTerms";
import { phraseMatches, singleWordScore, wordStats } from "./phraseMatch";

const byScoreDesc = (scored) => scored.sort((a, b) => b.score - a.score).map(({ term }) => term);
// Held terms go last in their list rather than disappearing.
const ALREADY_HELD_PENALTY = 1000;

// Most relevant first: API matches, then terms the typed words read as a phrase, then last-word
// matches. `committed` is what the search already holds as pills.
export function rankTerms({ fragment, text, termIndex, interpretedTerms = [], relatedCap, committed = [] }) {
  const stats = wordStats(termIndex);
  const heldIds = new Set(committed.map((c) => c.id));
  const holdsLevel = committed.some((c) => c.sourceType === "geographyLevel");
  // A search groups by one geography level, so a second one is unlikely too.
  const alreadyCovered = (term) =>
    heldIds.has(term.id) || (holdsLevel && term.sourceType === "geographyLevel");

  const { exactMatches, relatedMatches } = matchTerms(fragment, termIndex, { relatedCap });
  const interpretedIds = new Set(interpretedTerms.map((term) => term.id));
  const phrases = phraseMatches(text, termIndex, { stats }).filter(({ term }) => !interpretedIds.has(term.id));
  const rankedFirst = [...interpretedTerms, ...phrases.map(({ term }) => term)];
  const rankedIds = new Set(rankedFirst.map((term) => term.id));

  const scoreOf = (term) => ({
    term,
    score: singleWordScore(fragment, term, stats) - (alreadyCovered(term) ? ALREADY_HELD_PENALTY : 0),
  });
  const rest = byScoreDesc(exactMatches.filter((term) => !rankedIds.has(term.id)).map(scoreOf));
  const lastIfCovered = (terms) => [
    ...terms.filter((term) => !alreadyCovered(term)),
    ...terms.filter(alreadyCovered),
  ];

  return {
    exactMatches: lastIfCovered([...rankedFirst, ...rest]),
    relatedMatches: byScoreDesc(relatedMatches.map(scoreOf)),
    phrase: phrases.length ? text.slice(phrases[0].start).trim() : null,
  };
}
